import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { makeStyles } from '@material-ui/core/styles';
import sanitizer from '../../services/sanitize-service';
import { getTranslation } from '../../utils/functions';
import { CustomTheme } from '../../appTemplates/MUIProviderTemplate/MUIProviderTemplateInterfaces';

const useBulletStyles = makeStyles((theme: CustomTheme) => ({
  listItem: {
    alignItems: 'flex-start',
    paddingLeft: 0,
  },
  icon: {
    marginTop: theme.spacing(1),
    color: theme.palette.common.black,
    minWidth: theme.spacing(5),
    '& > svg': {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
  },
}));

interface IBullet {
  text: string;
  hint?: string;
}

interface IBulletListProps {
  bullets: IBullet[];
}

const BulletList: React.FC<IBulletListProps> = ({ bullets }) => {
  const classes = useBulletStyles();
  if (!bullets.length) return null;

  return (
    <List component="ul">
      {bullets.map(({ text, hint }, index) => (
        <ListItem className={classes.listItem} key={`bullet-${index}`}>
          <ListItemIcon className={classes.icon}>
            <FiberManualRecordIcon />
          </ListItemIcon>
          <div>
            <ListItemText
              primary={
                <span dangerouslySetInnerHTML={{ __html: sanitizer(getTranslation(text)) }} />
              }
            />
            {hint && (
              <>
                <br />
                <ListItemText
                  secondary={
                    <span dangerouslySetInnerHTML={{ __html: sanitizer(getTranslation(hint)) }} />
                  }
                />
              </>
            )}
          </div>
        </ListItem>
      ))}
    </List>
  );
};

export default BulletList;
